import React, { ReactElement } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames/bind';
import styles from 'sections/Home/components/SectionAbout/SectionAbout.module.scss';
import ImageMap from '../../../../../public/images/pages/Home/map.webp';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>
        <div className={cn('about__map-box')}>
          <Image
            sizes="100vw"
            style={{
              width: '100%',
              height: 'auto',
            }}
            className={cn('about__map')}
            src={ImageMap}
            alt="map"
          />
        </div>
        <div className={cn('about__info-box')}>
          <h2 className={cn('about__heading')}>About us</h2>
          <div className={cn('about__description')}>
            <p className={cn('about__description-paragraph')}>
              Digital Freight Alliance Network was founded in 2020 by DP World. Six years later and we are a freight
              network of over <span className={cn('about__text-bold')}>8,000</span> members.
            </p>
            <p className={cn('about__description-paragraph')}>
              The Alliance network is an independent freight forwarders’ association covering more than{' '}
              <span className={cn('about__text-bold')}>190</span> countries.
            </p>
            <p className={cn('about__description-paragraph')}>
              We provide members with web-based tools, networking and commercial opportunities across sea, air, and
              land.
            </p>
            <p className={cn('about__description-paragraph')}>
              Sign up for a wide range of benefits and opportunities that can be found here for freight forwarders.
            </p>
          </div>
          <div className={cn('about__buttons')}>
            {/* New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
            {/* <Link className={cn('about__button-plans')} href="/membership">
              Membership plans
            </Link> */}
            <Link className={cn('about__button-terms')} href="/resources/terms-and-conditions">
              View terms and conditions
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionAbout;